
import StepContent from "@/components/products/schatzbuch/steps/StepContentImpl.vue"
import Steps from "@/components/common/Steps.vue"
import { AppModule } from '@/store/modules/app'
import { Component } from 'vue-property-decorator'
import Configuration from '@/components/common/Configuration.vue'
import { TreasureBookModule, BackDetailState } from '@/store/modules/treasureBook'

@Component({
    name: "configuration",
    components: {
        Steps,
        StepContent
    }
})
export default class ConfigurationImpl extends Configuration {
    
    stepActivated(index:number):void {
        if(index === 3) {
            TreasureBookModule.SetBackDetailState(BackDetailState.TEXT)
        }
        AppModule.SetActiveStep(index)
        this.$emit("toggleFooterButton", false)
    }

    onCancel():void {
        if(this.currentStepIndex > 0) {
            AppModule.SetActiveStep(this.currentStepIndex - 1)
            /*this.$emit("toggleFooterButton", true)*/
        }
    }
    
    onConfirm():void {
        AppModule.CompleteCurrentStep()
        if(this.currentStepIndex < this.numberOfSteps - 1) {
            AppModule.SetActiveStep(this.currentStepIndex + 1)
            /*this.$emit("toggleFooterButton", true)*/
        } else {
            AppModule.SetShowMenu()
            this.$emit("toggleFooterButton", true)
        }
    }

    goToMenu() {
        this.$refs.stepContent.goToMenu()
    }
}
